import {
  FileMultipleStroke,
  FilePlusCircleStroke,
  Pencil1Stroke,
  PrinterStroke,
  Trash3Stroke
} from '@lineiconshq/free-icons';
import { Lineicons } from '@lineiconshq/react-lineicons';
import { TEMPLATE_BASE64 as excelTemplate_tong_hop_hach_toan_phieu_ke_toan_theo_nghiep_vu_PKTTNV } from '@/lib/templates-base64/PKTTNV';
import { AritoActionBar, AritoActionButton, AritoIcon, AritoMenuButton } from '@/components/custom/erp';
import { downloadBase64Excel } from '@/lib/template-downloader';
import { usePhieuKeToanTheoNghiepVuContext } from '../context';
import { useAuth } from '@/contexts/auth-context';

/**
 * Props for the ActionBar component
 */
interface ActionBarProps {
  isViewDisabled?: boolean;
  onAddClick?: () => void;
  onEditClick?: () => void;
  onDeleteClick?: () => void;
  onCopyClick?: () => void;
  onSearchClick?: () => void;
  onRefreshClick?: () => void;
  onFixedColumnsClick?: () => void;
  onMultiPrintClick?: () => void;
  onExportClick?: () => void;
  onExportExcelClick?: () => void;
  onImportExcelClick?: () => void;
}

/**
 * ActionBar component for the Balance Sheet by Unit page
 */
const ActionBar: React.FC<ActionBarProps> = ({
  isViewDisabled = false,
  onAddClick,
  onEditClick,
  onDeleteClick,
  onCopyClick,
  onSearchClick,
  onFixedColumnsClick,
  onRefreshClick,
  onMultiPrintClick,
  onExportClick,
  onImportExcelClick
}) => {
  const { canExport, isExporting, isLoadingImport } = usePhieuKeToanTheoNghiepVuContext();

  const handleDownloadExcelTemplate = () => {
    downloadBase64Excel(
      excelTemplate_tong_hop_hach_toan_phieu_ke_toan_theo_nghiep_vu_PKTTNV,
      'Phiếu kế toán theo nghiệp vụ.xlsx'
    );
  };

  return (
    <AritoActionBar titleComponent={<h1 className='text-xl font-bold'>Phiếu kế toán theo nghiệp vụ</h1>}>
      {onAddClick && <AritoActionButton title='Thêm' icon={FilePlusCircleStroke} onClick={onAddClick} />}
      {onEditClick && (
        <AritoActionButton title='Sửa' icon={Pencil1Stroke} onClick={onEditClick} disabled={isViewDisabled} />
      )}
      {onDeleteClick && (
        <AritoActionButton title='Xóa' icon={Trash3Stroke} onClick={onDeleteClick} disabled={isViewDisabled} />
      )}
      {onCopyClick && (
        <AritoActionButton title='Sao chép' icon={FileMultipleStroke} onClick={onCopyClick} disabled={isViewDisabled} />
      )}
      <AritoMenuButton
        title='In ấn'
        icon={<Lineicons aria-hidden='true' icon={PrinterStroke} size={18} />}
        items={[
          {
            title: 'Chứng từ hạch toán',
            icon: <AritoIcon icon={20} />,
            onClick: onRefreshClick,
            group: 0
          },
          {
            title: 'Chứng từ hạch toán (ngoại tệ)',
            icon: <AritoIcon icon={20} />,
            onClick: onSearchClick,
            group: 0
          },
          {
            title: 'Chứng từ hạch toán (song ngữ)',
            icon: <AritoIcon icon={20} />,
            onClick: onRefreshClick,
            group: 1
          },
          {
            title: 'Chứng từ hạch toán (ngoại tệ, song ngữ)',
            icon: <AritoIcon icon={20} />,
            onClick: onFixedColumnsClick,
            group: 1
          }
        ]}
      />

      <AritoMenuButton
        title='Khác'
        items={[
          {
            title: 'Tìm kiếm',
            icon: <AritoIcon icon={12} />,
            onClick: onSearchClick,
            group: 0
          },
          {
            title: 'Refresh',
            icon: <AritoIcon icon={15} />,
            onClick: onRefreshClick,
            group: 1
          },
          {
            title: 'Cố định cột',
            icon: <AritoIcon icon={16} />,
            onClick: onFixedColumnsClick,
            group: 1
          },
          {
            title: 'In nhiều',
            icon: <AritoIcon icon={883} />,
            onClick: onMultiPrintClick,
            group: 2
          },
          {
            title: 'Kết xuất dữ liệu',
            icon: <AritoIcon icon={555} />,
            onClick: onExportClick,
            disabled: !canExport || isExporting,
            group: 2
          },
          {
            title: 'Tải mẫu Excel',
            icon: <AritoIcon icon={28} />,
            onClick: handleDownloadExcelTemplate,
            group: 3
          },
          {
            title: 'Lấy dữ liệu từ Excel',
            icon: <AritoIcon icon={29} />,
            onClick: onImportExcelClick,
            group: 3
          }
        ]}
      />
    </AritoActionBar>
  );
};

export default ActionBar;
